'use client'

import React from 'react'
import {
  ExhibitionArtistItemFragment,
  GetExhibitionPageQuery,
  GetSimilarLiveExhibitionsQuery
} from '@/gql/generated/graphql'
import { redirect } from 'next/navigation'
import { ExhibitionHeader } from '../[slug]/components/header'
import { MoreExhibitions } from '../[slug]/components/more-exhibitions'
import { BehindTheExhibition } from './behind-the-exhibition'
import { GroupExhibitionQ42024ArtistSection } from './artist-section'
import { GroupExhibitionQ42024AboutSection } from './about-section'
import { GroupExhibitionQ42024PopUpCTA } from './pop-up-cta'
import { GroupExhibitionQ42024WorksSection } from './works-section'
import { getPrefixedLinkPath } from '@components/prefixed-link'
import { ShopifyProduct } from '@utils/shopify'

export const iskraAnchor = 'iskra'
export const larsAnchor = 'lars'
export const zachAnchor = 'zach'

export const iskraShopifyProduct: ShopifyProduct = {
  productId: `gid://shopify/Product/${process.env.NEXT_PUBLIC_SHOPIFY_INK_PRODUCT_ID}`,
  variantId: `gid://shopify/ProductVariant/${process.env.NEXT_PUBLIC_SHOPIFY_INK_VARIANT_ID}`
}

export const larsShopifyProduct: ShopifyProduct = {
  productId: `gid://shopify/Product/${process.env.NEXT_PUBLIC_SHOPIFY_FABRIC_PRODUCT_ID}`,
  variantId: `gid://shopify/ProductVariant/${process.env.NEXT_PUBLIC_SHOPIFY_FABRIC_VARIANT_ID}`
}

export const zachShopifyProduct: ShopifyProduct = {
  productId: `gid://shopify/Product/${process.env.NEXT_PUBLIC_SHOPIFY_SCULPTURE_PRODUCT_ID}`,
  variantId: `gid://shopify/ProductVariant/${process.env.NEXT_PUBLIC_SHOPIFY_SCULPTURE_VARIANT_ID}`
}

export const iskraTitle = 'INK'
export const larsTitle = 'while true'
export const zachTitle = 'Box Light Studies'

export const GroupExhibitionQ42024Display = ({
  exhibition,
  moreExhibitions
}: {
  exhibition: GetExhibitionPageQuery | undefined
  moreExhibitions: GetSimilarLiveExhibitionsQuery | undefined
}): React.ReactElement => {
  const exhData = exhibition?.exhibitions?.data?.[0]?.attributes
  if (!exhData) {
    redirect('/404')
  }

  const artists: { artist?: ExhibitionArtistItemFragment | null }[] = []
  exhData.Collections.forEach((collection) =>
    collection?.Collection?.Project?.artistPage?.data.forEach((artist) => artists.push({ artist: artist.attributes }))
  )

  // sort artists by artist name
  artists.sort((a, b) => {
    if (!a?.artist || !b?.artist) {
      return 0
    }
    return a.artist.artistName > b.artist.artistName ? 1 : -1
  })

  return (
    <div className="relative">
      <ExhibitionHeader
        title={exhData.Title}
        splashHeroImage={getPrefixedLinkPath('/images/poetics/hero/hero.jpg')}
        subtitle={artists.map((a) => a.artist?.artistName).join(', ')}
        description={
          <span>
            Through fragrance, geometries, and light, three artists contemplate infinity as an unfolding encounter,
            offering the viewer glimpses into the endless experiences that lie beyond simple representation.
          </span>
        }
        cta={<GroupExhibitionQ42024PopUpCTA exhibition={exhData} />}
      />
      <GroupExhibitionQ42024AboutSection exhibition={exhData} />
      <GroupExhibitionQ42024WorksSection exhibition={exhData} />
      <BehindTheExhibition />
      <GroupExhibitionQ42024ArtistSection exhibition={exhData} />
      <MoreExhibitions exhibitions={moreExhibitions} />
    </div>
  )
}
